export const SUPPORT_NUMBER = {
  label: '(888) 316-0451',
  raw: '8883160451',
};
